import { render, staticRenderFns } from "./ErroWs.vue?vue&type=template&id=4f0615c6"
import script from "./ErroWs.vue?vue&type=script&lang=ts"
export * from "./ErroWs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports